import React, { useEffect } from "react";
import { XCircle } from "lucide-react";
import { useToast } from "@/hooks/use-toast";

const PaymentFailedPage = () => {
  const { toast } = useToast();
  const ua = (typeof navigator !== "undefined" && navigator.userAgent) || "";
  const platform = (typeof navigator !== "undefined" && (navigator as any).platform) || "";
  const maxTouchPoints = (typeof navigator !== "undefined" && (navigator as any).maxTouchPoints) || 0;
  const isIOS = /iPad|iPhone|iPod/i.test(ua) || (platform === "MacIntel" && maxTouchPoints > 1);
  const isAndroid = /Android/i.test(ua);
  const isMobile = isAndroid || isIOS;

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6 md:p-4">
      <div className="max-w-md w-full">
        {/* Main Card */}
        <div className="bg-white rounded-2xl shadow-lg m-4 text-center min-h-[400px] md:min-h-[350px] flex flex-col justify-center">
          {/* Failed Icon */}
          <div className="mb-6">
            <div className="w-16 h-16 md:w-20 md:h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <XCircle className="w-10 h-10 md:w-12 md:h-12 text-red-600" />
            </div>
          </div>

          {/* Failed Message */}
          <h1 className="text-xl md:text-2xl font-bold text-gray-800 mb-3">
            Payment Unsuccessful!
          </h1>

          <div className="text-sm md:text-base text-gray-600 leading-relaxed">
            <p>We're sorry, but your payment could not be processed.</p>
            <p>Please retry from the app after closing this tab.</p>
          </div>

          {/* Loading indicator */}
          {/* <div className="flex items-center justify-center mb-4">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-green-600"></div>
          </div> */}

          {/* Manual redirect link - shows after a delay */}
          <div className="mt-4">
            {!isIOS && (
              <a
                id="manualLink"
                href={isMobile ? "inmynamekyc://" : "#"}
                onClick={(e) => {
                  if (!isMobile) {
                    e.preventDefault();
                    const tryClose = () => {
                      try { window.open("", "_self"); } catch {}
                      try { window.close(); } catch {}
                      try { window.top && (window.top as Window).close && (window.top as Window).close(); } catch {}
                      try { (self as any).close && (self as any).close(); } catch {}
                    };
                    tryClose();
                    setTimeout(() => {
                      if (document.visibilityState === "visible") {
                        toast({
                          title: "Unable to close tab",
                          description: "Your browser blocked closing. Please close this tab manually.",
                        });
                      }
                    }, 200);
                  }
                }}
                className="inline-block px-4 py-2 bg-[#4c7375] hover:bg-[#243d3d] text-white text-sm font-semibold rounded-lg transition-colors duration-200"
              >
                {isMobile ? "Open App" : "Close Page"}
              </a>
            )}

            {
              isIOS && (
                <a
                href={"#"}
                onClick={(e) => {
                  e.preventDefault();
                  try {
                    const redirectParams = new URLSearchParams();
                    redirectParams.set("payment_success", "no");
                    const query = redirectParams.toString();
                    const target = "/onboarding" + (query ? `?${query}` : "");
                    window.location.assign(target);
                  } catch {
                    const query = "?payment_success=no";
                    window.location.href = "/onboarding" + query;
                  }
                }}
                className="inline-block px-4 py-2 bg-[#4c7375] hover:bg-[#243d3d] text-white text-sm font-semibold rounded-lg transition-colors duration-200"
                >
                Return to the App
               </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailedPage;
